class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector("dialog");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.querySelectorAll('[ref="closeCartNotification"]').forEach(
      (element) => {
        element.addEventListener("click", this.handleCloseClick.bind(this));
      }
    );
  }

  handleBodyClick(event) {
    if (event.target === this.dialog) this.close();
  }

  handleCloseClick(event) {
    event && event.preventDefault();
    this.close();
  }

  open() {
    this.dialog.showModal();
    document.documentElement.classList.add("overflow-hidden");
    document.body.addEventListener("click", this.onBodyClick);
    publish(PUB_SUB_EVENTS.dialogOpen);
  }

  close() {
    this.dialog.close();
    document.documentElement.classList.remove("overflow-hidden");
    document.body.removeEventListener("click", this.onBodyClick);
    publish(PUB_SUB_EVENTS.dialogClose);
  }

  renderContents(parsedState) {
    console.log(parsedState);
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      console.log(section, this.cartItemKey);
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-notification", CartNotification);
